/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsaved1Inputs */

const en_signupsaved1 = /** @type {(inputs: Signupsaved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-up saved`)
};

const de_signupsaved1 = /** @type {(inputs: Signupsaved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung gespeichert`)
};

/**
* | output |
* | --- |
* | "Sign-up saved" |
*
* @param {Signupsaved1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsaved1 = /** @type {((inputs?: Signupsaved1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsaved1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsaved1(inputs)
	return de_signupsaved1(inputs)
});
export { signupsaved1 as "signupSaved" }